

















import { Component, Prop, Vue } from 'vue-property-decorator'

export type Pagination = {
  page: number
  limit: number
  totalCount: number
}

@Component({})
export default class PaginationButton extends Vue {
  /* ボタン内の中心領域に表示するページ数 */
  @Prop({ default: 5 })
  private pageRange!: number
  /* ボタン内の両端領域に表示するページ数 */
  @Prop({ default: 3 })
  private marginPages!: number
  /* ページネーションボタンのページ数 */
  private pageCount = 0
  /* ページネーションボタンにて現在選択しているページ */
  private currentPage = 1
  /* ページネーション表示/非表示フラグ */
  private isVisible = false

  public get paginationCurrentPage(): number {
    return this.currentPage
  }

  public paging(pagination: Pagination) {
    if (pagination.totalCount > pagination.limit) {
      this.isVisible = true
    } else {
      this.isVisible = false
    }
    this.pageCount = Math.ceil(pagination.totalCount / pagination.limit)
    this.currentPage = pagination.page
  }

  private async onClickPaginationButton(page: number) {
    this.currentPage = page
    this.$emit('click-handler')
  }
}
